import { InputTextLabel } from "../input-text-label/input-text-label";
import { InputTextStyle, InputTextContainer } from "./style"

interface InputTextProps {
    placeholder?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    name?: string;
    type?: string;
    color?: string;
    label?: string;
}
export const InputText: React.FC<InputTextProps> = ({ placeholder, value, name, onChange, onKeyDown, color, label }) => {
    return (
        <InputTextContainer>
            <InputTextLabel label={label ?? ""} color={color} marginbottom="5px" />
            <InputTextStyle
                type="text"
                placeholder={placeholder ?? ""}
                value={value ?? ""}
                name={name}
                onChange={onChange}
                onKeyDown={onKeyDown}
                color={color}
            />
        </InputTextContainer>
    )
}   